<template>
	<el-container class="home">
		<el-header class="header">
			<img src="http://quanlang.top/static/img/indexlogo.png" style="width: 220px;height: 56px;">
			<div class="icon">
				<i class="el-icon-s-fold"></i>
			</div>
		</el-header>
		<el-container>
			<el-aside width="240px" style="background-color:rgb(31, 34, 36);" class="left">
				<div class="info">
					<img src="https://hbimg.huabanimg.com/6d7a118eaf6b3480fdb289847f5e16778f1848636409-hrWFIb_fw236"
						style="width: 86px;height: 86px;border-radius: 50%;margin-bottom: 10px;">
					<span>安</span>
					<span>ID:1129</span>
				</div>
				<div style="flex: 1;background-color: rgb(40, 45, 47);">
					<el-menu default-active="2" class="el-menu-vertical-demo" background-color="#282d2f"
						text-color="#868e8e" active-text-color="#fff" >
						<el-menu-item :index="item.index" v-for="(item,index) in menus" :key="index">
							<i :class="item.icon"></i>
							<span slot="title">{{item.title}}</span>
						</el-menu-item>
					</el-menu>
				</div>
			</el-aside>
			<el-main style="background-color: rgb(134, 142, 142);">Main</el-main>
		</el-container>
	</el-container>
</template>

<script>
	// @ is an alias to /src

	export default {
		name: 'HomeView',
		data(){
			return {
				menus:[{
					title:'首页',
					path:"/home",
					icon:'el-icon-s-home',
					index:'1'
				},{
					title:'首页',
					path:"/home",
					icon:'el-icon-s-home',
					index:'2'
				},{
					title:'首页',
					path:"/home",
					icon:'el-icon-s-home',
					index:'3'
				},{
					title:'首页',
					path:"/home",
					icon:'el-icon-s-home',
					index:'4'
				}]
			}
		}
	}
</script>

<style>
	.home {
		width: 100%;
		height: 100vh;
		display: flex;
		overflow: hidden;
	}

	.home .header {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 20px;
	}

	.home .icon {
		width: 65px;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 30px;
		border-right: 1px solid #282d2f;
		color: #fff;
	}

	.home .left {
		display: flex;
		flex-direction: column;
	}

	.home .left .info {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 40px;
	}

	.home .left .info span {
		font-size: 15px;
		color: #cfcfcf;
		margin-top: 5px;
	}
</style>